import React, { useRef } from "react";
// import { motion } from "framer-motion";
// import TeamSlider from "../components/teamSlider";
import CaseStudyCard from "../components/caseStudyCard";
import { boxData, CaseStudies } from "../utiles/constant";
import TechStack from "../components/techStack";
import FlowDiagram from "../components/projectTimeLine";
import TestimonialList from "../components/testimonialList";
import ImageSlider from "../components/imageSlider";
import { mobilenumber } from '../utiles/constant'
import { Link } from "react-router-dom";
const BusinessOverView = () => {
  const caseStudiesRef = useRef(null);
  // Scroll to case studies section
  const scrollToCaseStudies = () => {
    if (caseStudiesRef.current) {
      caseStudiesRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="p-4 md:p-8 lg:px-14 xl:px-32">
      <div className="grid grid-cols-1 lg:grid-cols-2 p-2 lg:py-4 lg:px-1 bg-white ">
        <div className=" mb-8 md:mb-0 mt-3">
          <h1 className="text-2xl font-bold mb-4 lg:text-4xl">
            Where <span className="text-primary">Technology</span>
            <br />
            Meets Ingenuity!
          </h1>
          <p className="text-gray-500 mb-6">
          I do not just code, I conquer. Your one-stop service center to manage your business and needs.
          </p>
          <div className="flex mb-6">
            <div className="mr-8">
              <p className="text-3xl font-bold">120+</p>
              <p className="text-gray-600">successful projects</p>
            </div>
            <div>
              <p className="text-3xl font-bold">120+</p>
              <p className="text-gray-600">satisfied clients</p>
            </div>
          </div>
          <div className="flex space-x-4">
           
            <Link
               to={`tel:${mobilenumber.phone}`}
               className="bg-primary text-white hover:bg-white hover:text-primary px-6 py-2 lg:py-3 text-[12px] rounded-3xl lg:text-sm lg:px-6 rounded-3xl hover:border hover:border-primary"
            >
              Book a free call
            </Link>
            <button 
              className="text-primary hover:bg-primary hover:text-white px-6 py-2 lg:py-3 text-[12px] lg:text-sm lg:px-6 rounded-3xl border border-primary"
              onClick={scrollToCaseStudies} 
            >
              See projects
            </button>
          </div>
        </div>
        <ImageSlider />
      </div>

      {/* <div className="text-center mt-6 mb-8">
        <p className="text-xl md:text-2xl lg:text-3xl font-bold text-primary mb-4">
          Meet our Team
        </p>
        <p className="text-sm md:text-base lg:text-base text-gray-500 max-w-3xl mx-auto">
        Our IT consulting process consists of a structured journey with four key stages: Evaluation and Analysis, Strategic Planning, Implementation and Execution, and Monitoring and Optimization.{" "}
        </p>
      </div>
      <TeamSlider /> */}
      <TechStack />

      <div className="w-full py-2 lg:px-1 mt-2" ref={caseStudiesRef}>
        <h1 className="text-2xl text-center mb-2">My recent </h1>
        <h2 className="text-3xl font-bold text-center mb-16 text-primary">
          Case Studies
        </h2>
        {CaseStudies.map((project) => (
          <CaseStudyCard
            key={project.id}
            bgColor={project.bgColor}
            imgSrc={project.imgSrc}
            title={project.title}
            description={project.description}
            textColor={project.textColor}
            projectId={project.id} 
          />
        ))}
      </div>
      
      <div className="w-full mt-8">
        <h1 className="text-2xl text-center mb-2">How development </h1>
        <h2 className="text-3xl font-bold text-center mb-8 text-primary">
          through Alcaline works
        </h2>
        <FlowDiagram />
      </div>

      <div className="justify-center text-center py-2 mt-8">
        <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-sans font-bold text-primary leading-tight mb-4 sm:mb-6">
          My services for you
        </h2>
        <p className="text-sm sm:text-base md:text-lg lg:text-base text-gray-500 leading-relaxed mb-4 sm:mb-6">
        I believe that I will deliver excellent systems to my customers.
    </p>
          <div className="p-2 md:p-2 mt-8 ">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {boxData.map((box, index) => (
                <div
                  key={index}
                  className="relative bg-white rounded-lg shadow-lg overflow-hidden transition-transform transform hover:scale-105 group hover:bg-primary"
                  style={{
                    transition: "background-color 2s ease, transform 2s ease",
                  }}
                >
                  <div
                    className="flex items-center justify-center h-24 group-hover:scale-x-110 "
                    style={{ transition: "transform 0.5s ease" }} 
                  >
                    {box.icon}
                  </div>
                  <div className="p-4 flex flex-col justify-between h-full">
                    <div className="flex-1">
                      <h3
                        className="text-xl font-semibold text-primary mb-2 transition-colors duration-300 ease-in-out group-hover:text-white group-hover:scale-105"
                        style={{ transition: "color 0.5s ease" }} 
                      >
                        {box.name}
                      </h3>
                      <p
                        className="text-sm text-gray-500 mb-4 transition-colors duration-300 ease-in-out group-hover:text-white group-hover:scale-105"
                        style={{
                          transition: "color 0.5s ease, transform 0.5s ease",
                        }} 
                      >
                        {box.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
      </div>

      <div className="lg:flex flex-wrap gap-6 px-2 mt-8 grid sm:grid-cols-1 md:grid-cols-2 ">
        <div className="flex-1 min-w-[300px] lg:w-1/2 sticky-none z-0 transition-colors lg:sticky top-0 xlg-custom:sticky md:sticky sm:sticky  self-start">
          <h3 className="text-lg sm:text-base md:text-base lg:text-xl font-bold text-blue-500 mb-3">
            Testimonial
          </h3>
          <h2 className="text-2xl md:text-2xl sm:text-3xl lg:text-4xl text-primary font-bold mb-3">
            What Clients Say
          </h2>
          <div className="text-sm sm:text-sm md:text-sm lg:text-[17px] text-gray-500">
            <p>
              Here are a few of the most inspiring reviews from our clients.
              Your insights are crucial to us, driving our commitmen
              continually evolve, enhance our craft, and perfect our approach.
            </p>
          </div>
        </div>
        <TestimonialList />
      </div>
    </div>
  );
};

export default BusinessOverView;
